import React from 'react';
import ThumborImageService from '@/utils/thumbor-image-service';
import ThumborFit from '@/enums/thumbor-fit';

// env var without trailing slash
const MEDIA_BUCKET_URL = process.env.MEDIA_BUCKET.replace(/\/$/, '');

const splitImagePath = src => {
	if (src.includes('imgix.net')) {
		return src.split('.imgix.net/')[1];
	}
	if (src.startsWith(MEDIA_BUCKET_URL)) {
		return src.split(`${MEDIA_BUCKET_URL}/`)[1];
	}
	return src;
};

const convertToThumborUrl = (src, params = {}) => {
	const imgPath = splitImagePath(src);

	try {
		const thumborServiceInstance = ThumborImageService.getInstance();
		const thumbnailPath = thumborServiceInstance.getThumborUrlForImage(imgPath, params.w, params.h, {
			fit: ThumborFit.IN,
		});

		// Thumbor doesn't support gifs
		if (imgPath.endsWith('.gif')) {
			return `https://media${thumbnailPath.split('https://media')[1]}`;
		}

		return thumbnailPath;
	} catch {
		console.error('Failed to convert imgix url to thumbor url, using media-bucket instead', imgPath);
		return `${MEDIA_BUCKET_URL}/${encodeURIComponent(imgPath)}`;
	}
};

// Recursive loop to find all img-tags and update their src prop with the specified query-params
export const updateParamsOnImgChildren = (children, params) => {
	try {
		const c = React.Children.map(children, childNode => {
			if (childNode?.type === 'img') {
				const { src } = childNode.props;

				if (src && (src.indexOf('imgix.net') !== -1 || src.startsWith(MEDIA_BUCKET_URL))) {
					const correctedSrc = convertToThumborUrl(src, params);
					return React.cloneElement(
						childNode,
						{ ...childNode.props, src: correctedSrc },
						updateParamsOnImgChildren(childNode.props.children, params)
					);
				}

				return childNode;
			}

			if (childNode?.props?.children) {
				return React.cloneElement(childNode, [], updateParamsOnImgChildren(childNode.props.children, params));
			}
			return childNode;
		});

		return c;
	} catch {
		return children;
	}
};
